import { useSelector } from 'react-redux';

/**
 * Custom hook to access globally calculated funds data
 * Can be used in any component that needs access to funds information
 */
const useBalance = () => {
  // Get the calculated funds data from the Redux store
  const calculatedFunds = useSelector(state => state.funds.calculatedfunds || {});
  
  // Return a well-structured object with all funds data
  return {
    // Main balance values
    availableCash: parseFloat(calculatedFunds.availableCash || 0),
    tradingBalance: parseFloat(calculatedFunds.tradingBalance || 0),
    equity: parseFloat(calculatedFunds.equity || 0),
    
    // PnL values
    unrealizedPnl: parseFloat(calculatedFunds.unrealizedPnl || 0),
    realizedPnl: parseFloat(calculatedFunds.realizedPnl || 0),
    totalPnl: parseFloat(calculatedFunds.totalPnl || 0),
    
    // Other values
    blockedMargin: parseFloat(calculatedFunds.blockedMargin || 0),
    credit: parseFloat(calculatedFunds.credit || 0),
    
    // Raw data for direct access if needed
    rawData: calculatedFunds.rawData || {},
    
    // Formatted values (with currency symbol and 2 decimal places)
    formatted: {
      availableCash: `₹${parseFloat(calculatedFunds.availableCash || 0).toFixed(2)}`,
      tradingBalance: `₹${parseFloat(calculatedFunds.tradingBalance || 0).toFixed(2)}`,
      equity: `₹${parseFloat(calculatedFunds.equity || 0).toFixed(2)}`,
      unrealizedPnl: `₹${parseFloat(calculatedFunds.unrealizedPnl || 0).toFixed(2)}`,
      realizedPnl: `₹${parseFloat(calculatedFunds.realizedPnl || 0).toFixed(2)}`,
      totalPnl: `₹${parseFloat(calculatedFunds.totalPnl || 0).toFixed(2)}`,
      blockedMargin: `₹${parseFloat(calculatedFunds.blockedMargin || 0).toFixed(2)}`,
      credit: `₹${parseFloat(calculatedFunds.credit || 0).toFixed(2)}`
    },
    
    // Helper for checking if values are positive
    isPositive: {
      unrealizedPnl: parseFloat(calculatedFunds.unrealizedPnl || 0) >= 0,
      realizedPnl: 0,
      totalPnl: parseFloat(calculatedFunds.totalPnl || 0) >= 0
    }
  };
};

export default useBalance; 